export default __webpack_public_path__ + "static/media/8.6b564d7c.png";